import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getSuppliers({ commit }, data) {
      try {
        const response = await api.get('/documents/suppliers')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getSupplier({ commit }, cgccfo) {
      try {
        const response = await api.get(`/documents/suppliers/${cgccfo}/info`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async createSupplierDocument({ commit }, data) {
      try {
        return await api.post(
          `/documents/suppliers/${data.cgccfo}`,
          data.formData,
        )
      } catch (error) {
        throw error
      }
    },

    async getSupplierDocuments({ commit }, cgccfo) {
      try {
        const response = await api.get(`/documents/suppliers/${cgccfo}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async replaceSupplierDocument({ commit }, data) {
      try {
        return await api.post(
          `/documents/suppliers/${data.cgccfo}/files/${data.id}`,
          data.formData,
        )
      } catch (error) {
        throw error
      }
    },

    async updateSupplierDocument({ commit }, data) {
      try {
        return await api.put(
          `/documents/suppliers/${data.cgccfo}/files/${data.id}`,
          data.formData,
        )
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
